import React from 'react';
import CircularCardLabelWithTooltip from 'components/pure/utils/CircularCardLabelWithTooltip';
import ConstValues from 'utils/const';
import {scorecardTypes, labelOrDefaultTooltip} from 'records/Scorecard';
import 'styles/scorecards/results/ScorecardResultsUserScoreCircularCardLabel.styl';

/**
 * <ScorecardResultsUserScoreCircularCardLabel /> uses <CircularCardLabelWithTooltip /> to render
 * a circular label which also has a custom hover color and a custom react-portal-tooltip
 */
export default class ScorecardResultsUserScoreCircularCardLabel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {showTooltip: false};
  }

  /**
   * Update this.state.showTooltip to `true` in order to display the tooltip
   */
  showTooltip = () => {
    this.setState({showTooltip: true});
  };

  /**
   * Update this.state.showTooltip to `false` in order to hide the tooltip
   */
  hideTooltip = () => {
    this.setState({showTooltip: false});
  };

  /**
   * Return a css style object for <CircularCardLabelWithTooltip:hover />
   * @return {object} A style object for <CircularCardLabelWithTooltip:hover />
   */
  hoverStyle(answer) {
    if (this.state.showTooltip) {
      const backgroundColor = ConstValues.scorecardResultScoreToHoverColor.get(answer);
      return {
        backgroundColor: backgroundColor,
        color: 'white',
      };
    } else {
      return {};
    }
  }

  render() {
    const {scoringScheme, labelScheme} = this.props;
    const answer =
      !this.props.answer || this.props.answer.value === null ? 'n/a' : this.props.answer.value + '';

    const spanStyle = {
      color: this.props.spanColor,
    };

    const tooltip = labelOrDefaultTooltip(scoringScheme, answer, labelScheme);
    const keyLabel = scorecardTypes[scoringScheme].answers.find(a => a.key === answer).label;

    return (
      <CircularCardLabelWithTooltip
        label={keyLabel}
        hoverStyle={this.hoverStyle(answer)}
        spanStyle={spanStyle}
        tooltip={tooltip}
        showTooltip={this.state.showTooltip}
        onMouseEnter={this.showTooltip}
        onMouseLeave={this.hideTooltip}
      />
    );
  }
}
